import React from 'react';
import { useProductCard } from '../ProductCardContext';

const ProductImage = () => {
  const { productImage, name } = useProductCard();

  return (
    <div className="flex items-center h-full justify-center w-full min-w-0 overflow-hidden">
      <img
        alt={name}
        src={productImage}
        className="w-full h-full object-contain max-w-full max-h-full"
        style={{ mixBlendMode: 'darken' }}
        loading="lazy"
      />
    </div>
  );
};

export default ProductImage;
